import { render, staticRenderFns } from "./CashMargin.vue?vue&type=template&id=4c4d2f30&scoped=true&"
import script from "./CashMargin.vue?vue&type=script&lang=js&"
export * from "./CashMargin.vue?vue&type=script&lang=js&"
import style0 from "./CashMargin.vue?vue&type=style&index=0&id=4c4d2f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d2f30",
  null
  
)

export default component.exports